import { useMemo, useEffect } from 'react'
import { UserTypes } from "@/configs/AppConfig";
import { validatePageRights } from "@/lib/RightsUtils";
import { SYSTEM_USER_NAVIGATION_ITEMS, PATIENT_NAVIGATION_ITEMS } from "@/configs/NavigationConfig"


export default function useNavbar(userType, rights = []) {

    const navigation = useMemo(() => {
        if (!userType) return []
        if (userType == UserTypes.SYSTEM_USER) {
            return SYSTEM_USER_NAVIGATION_ITEMS.filter(item => validatePageRights(item.id, rights))
        }
        else if (userType == UserTypes.PATIENT) {
            return PATIENT_NAVIGATION_ITEMS
        }
        return []
    }, [userType])
    return {
        navigation
    }
}